import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AiProposedLabelProps {
  testId?: string;
}

/** Il valore e' dell'IA finche' l'utente non lo tocca: art. 50, il campo pre-compilato non deve sembrare inserito a mano. */
export function AiProposedLabel({ testId }: AiProposedLabelProps) {
  const { t } = useTranslation('documents');
  return (
    <Chip
      size="small"
      variant="outlined"
      color="info"
      icon={<AutoAwesomeOutlinedIcon />}
      label={t('deadlines.aiPreview.proposedByAi')}
      data-testid={testId ?? 'ai-proposed-label'}
      sx={{ alignSelf: 'flex-start' }}
    />
  );
}
